<div class="gmap-container">
  <div class="gmap-search-box-wrapper">
    <input
      #addresstext
      type="text"
      class="gmap-search-box"
      placeholder="Buscar ubicación"
    />
  </div>
  <div class="gmap-map-wrapper" style="display: flex; justify-content: center;">
    <google-map
      #map
      [center]="center"
      [zoom]="zoom"
      [options]="config"
      (mapClick)="geocodeLatLng($event)"
    >
      <map-marker
        *ngIf="selected?.location"
        [position]="selected.location"
        [options]="markerConfig"
      ></map-marker>
    </google-map>
  </div>
</div>
